<template>
  <div id="onebyone-navigation" class="noto-sans-sc-font-family">
    <div id="onebyone-nav-items-wrapper" class="mx-auto">
      <router-link to="/" class="nav-logo nav-item d-flex align-center">
        <v-img :src="getImage('/others/1byone_logo.svg')" max-width="90px" contain></v-img>
      </router-link>
      <div id="left-navigation" class="mx-auto d-flex justify-space-around">
        <div
          class="menu-item nav-item d-inline-flex align-center text-uppercase"
          @mousemove="showNavOverlayWithSubject(menu)"
          @mouseleave="hideNavOverlay"
          v-for="menu in menus"
          :key="menu.name"
        >
          <a :href="menu.landingPage">{{ menu.name }}</a>
        </div>
      </div>
    </div>

    <div id="right-navigation" class="d-flex">
      <!-- 气泡框显示 -->
      <div class="signbt position">
        <img :src="imgSrc" class="dialog-bt" @click="showDetaile()" />
        <!-- 动画效果 -->
        <transition name="hide">
          <div class="box_hezi" v-if="showBox">
            <div class="hezi_onediv">
              <div class="box_hezi_oneDiv"></div>
            </div>
            <!-- 页面主题内容Body -->
            <div class="box_hezi_twoDiv" v-if="twoDiv">

              <div class="box_hezi_Image">
                <img class="showImage" :src="sp_img" />
              </div>



                <div id="loginsuccessful1" v-if="showloginsuccessful">
                  <div id="titel-congratulations1"> Congratulations</div>
                  <img id="logingouzi1" src="../../assets/chenggong.png">
                  <div id="loginsuccessful1-content"> you have actived your warranty!</div>
                   <div id="affrim2" @click="showxingjipl()">NEXT</div>
                </div>

              <div class="box-right-form" v-if="showRightForm">

                <span class="closeButton" @click="closeBox">X</span>

                <div class="box-title">
                  <img class="box-title-image" src="../../assets/shield.png" />
                  <h3>Warranty Registration</h3>
                </div>

                <!-- <div class="eu_state_box" v-if="selectEU">
                 
                    <input v-model="radioVal" type="radio" name="state" value="UK">UK&nbsp;&nbsp;
                    <input v-model="radioVal" type="radio" name="state" value="DE">DE&nbsp;&nbsp;
                    <input v-model="radioVal" type="radio" name="state" value="FR">FR&nbsp;&nbsp;
                    <input v-model="radioVal" type="radio" name="state" value="IT">IT&nbsp;&nbsp;
                    <input v-model="radioVal" type="radio" name="state" value="ES">ES
                </div> -->

                <div class="box-content-text" v-if="showBoxText">

                  <span class="getWarranty">Get the 24 months extended </span>
                  <br />
                  <span class="getWarranty2">warranty for free</span>
                  <br />
                  <br />
                    
                  <div class="box-purchasing-channel">
                    <select name="purchasing-channel" id="cc" @change="changeChannel()">
                      <option value style="display: none;"  disabled selected>Where did you buy it?  ▼  </option>
                      <option value="amazon-US">Amazon US</option>
                      <option value="amazon-CA">Amazon CA</option>
                      <option value="amazon-EU">Amazon EU</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
    
                </div>

                <!-- <div class="box-content-text" v-if="showBoxAmazon">
                  <div class="box-amazon-bt" @click="getItemData">
                    <a id="LoginWithAmazon" >
                      <img
                        border="0"
                        alt="Login with Amazon"
                        src="https://images-na.ssl-images-amazon.com/images/G/01/lwa/btnLWA_gold_156x32.png"
                        width="156"
                        height="32"
                      />
                    </a>
                   </br>
                  </div>
                  <span class="box-amazon-flag">
                    *Make sure to sign in using the account
                  
                  </span >
                  <span class="box-amazon-flag">
                   
                    you used to purchase your product.
                  </span >
                </div> -->

                <div class="box-content-text" v-if="showBoxAmazon">
                  <div class="box-amazon-bt">
                    <div class="box-purchasing-channel">
                      <select name="purchasing-channel" id="cc" @change="changeChannel()">
                        <option value style="display: none;"  disabled selected>Where did you buy it?  ▼  </option>
                        <option value="amazon-US">Amazon US</option>
                        <option value="amazon-CA">Amazon CA</option>
                        <option value="amazon-EU">Amazon EU</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                    <div class="eu_state_box" v-if="selectEU">
                    <input v-model="radioVal" type="radio" name="state" value="UK">UK&nbsp;&nbsp;
                    <input v-model="radioVal" type="radio" name="state" value="DE">DE&nbsp;&nbsp;
                    <input v-model="radioVal" type="radio" name="state" value="FR">FR&nbsp;&nbsp;
                    <input v-model="radioVal" type="radio" name="state" value="IT">IT&nbsp;&nbsp;
                    <input v-model="radioVal" type="radio" name="state" value="ES">ES
                  </div>
                   <br>
                    <input type="text" id ="fristName" name="name" placeholder="Name*" />
                    <br>
                    <br>
                    <input type="text" id ="email" name="email" placeholder="Email*" />
                    <p style="margin-top:8%">Order Number*</p>
                    <input style="float:left;width:3em;margin-top:0%;border: solid 1px #CCCCCC;" type="text" id ="ordernumber1" name="ordernumber" size="3" maxlength="3" @keyup="transfer(1)"/><span style="float:left;color:#CCCCCC">—</span>
                    <input style="float:left;width:4.5em;margin-top:0%;border: solid 1px #CCCCCC;" type="text" id ="ordernumber2" name="ordernumber" size="7" maxlength="7" @keyup="transfer(2)"/><span style="float:left;color:#CCCCCC">—</span>
                    <input style="width:4.5em;margin-top:0%;border: solid 1px #CCCCCC;" type="text" id ="ordernumber3" name="ordernumber"  size="7" maxlength="7"/>
                    <div id="affrim" @click="affrimRecord">SUBMIT</div>
                  </div>
                </div>

                 


                <div class="box-content-text from" v-if="showBoxForm">
                  <div class="box-purchasing-channel">
                    <select name="purchasing-channel" id="cc" @change="changeChannel()">
                      <option value style="display: none;"  disabled selected>Where did you buy it?  ▼  </option>
                      <option value="amazon-US">Amazon US</option>
                      <option value="amazon-CA">Amazon CA</option>
                      <option value="amazon-EU">Amazon EU</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                  
                  <input type="text" id ="purchaseWaysName" name="name" placeholder="Name*" />
                  <input type="text" id ="purchaseWaysEmail" name="email" placeholder="Email*" />
                  <p style="margin-top:8%">Ways to purchase?</p>
                  <textarea name="purchaseWays" id="purchaseWays" cols="20" rows="4"></textarea>
                  <div id="affrim" @click="affrimRecord(1)">SUBMIT</div>
                </div>

              </div>
            </div>

                  <!--联系我们  -->
            <div class="box_hezi_twoDiv" v-if="showBoxCU">
              <span class="closeButton cuclose" @click="closeBox">X</span>
                <div class="box_hezi_Image">
                  <img class="cuimage" :src="sp_img"/>
                </div>
                <div class="box-text-right" v-if="showBoxCUright">
                  
                  <div class="box-text">
                    <h3><img src="../../assets/dialog.png">Need some help?</h3>
                    <span>Let us know what’s going on, and we’ll match you to a product specialist who will take it from here.</span>
                  </div>

                  <div class="box-select-product-from">
                    <form action="https://api.1byonehealth.com/ap/contact_info" method="post" id="selectFrom">

                      <div class="box-select-product" v-if="showSelectProduct">
                        <select name="selectproduct" id="sp" @change="changeSp()">
                          <option value style="display: none;" disabled selected>Choose the product of purchase&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;▽</option>
                          <option value="A01">Weight Scale(0014)</option>
                          <option value="A02">Weight Scale(0201)</option>
                          <option value="A03">Weight Scale(white) </option>
                          <option value="A04">Bluetooth Weight Scale(balck)</option>
                          <option value="A05">Bluetooth Fat Scale(balck)</option>
                          <option value="A06">Bluetooth Fat Scale(White)</option>
                          <option value="A07">Bluetooth Fat Scale ITO(Black)</option>
                          <option value="A08">Bluetooth Fat Scale ITO</option>
                          <option value="B01">Blood Pressure Monitor(white) </option>
                          <option value="B02">Blood Pressure Monitor(balck)</option>
                          <option value="B03">Blood Pressure Monitor(balck)</option>
                          <option value="B04">Bluetooth Blood Pressure Monitor(Black)</option>
                          <option value="B05">Bluetooth Blood Pressure Monitor(White)</option>
                          <option value="B06">Bluetooth Blood Pressure Monitor</option>
                          <option value="D01">ECG Monitor</option>
                          <option value="E01">TENS</option>
                        </select>
                      </div>
                      <br>
                      <span>Message*</span>
                      <br>
                      <input id="selectMessage" type="text" name="Review" placeholder="" />
                      <br>
                      <br>
                      <input id="selectFirstName" type="text" name="FirstName" placeholder="FirstName*" />
                      <input id="selectLastName" type="text" name="LastName" placeholder="LastName*" />
                      <br>
                      <br>
                      <input id="selectEmail" type="text" name="email" placeholder="Email*" />
                      <br>
                      <br>
                      <button type="button" @click="fromChoose">SUBMIT</button>
                    </form>
                    <br>
                    <span>Or you can contact us here：<br>
                          Email: help@1byone.com   Call: +1909-391-3888</span>
                  </div>
                </div>

                <!-- 星级评价 -->
                <div class="box-right-form grade" v-if="showBoxGrade">
                  <div class="box-title2 grade" >
                    <h4>Thanks for your reflection! Your review help us improving our products and service. </h4>
                  </div>
                  <div class="star" >
                    <img @mouseover="mouseOver(1)" 
        	             @mouseleave="mouseLeave"
                       @click="starClick(1)"
                       :src="star1" >
                    <img @mouseover="mouseOver(2)" 
        	             @mouseleave="mouseLeave"
                       @click="starClick(2)"
                        :src="star2">
                    <img @mouseover="mouseOver(3)" 
        	             @mouseleave="mouseLeave"
                       @click="starClick(3)"
                       :src="star3" >
                    <img @mouseover="mouseOver(4)" 
        	             @mouseleave="mouseLeave"
                       @click="starClick(4)"
                      :src="star4" >
                    <img @mouseover="mouseOver(5)" 
        	            @mouseleave="mouseLeave"
                      @click="starClick(5)"
                       :src="star5">    
                  </div>
                  <div class="box-content-text from gradefrom">
                    <form action="https://api.1byonehealth.com/ap/review" method="post" id="gradefrom">
                      <input type="hidden" id="star-num" name="starnum" v-model="starNum"></input>
                         
                      <!-- <div
                        v-for="tag in tags"
                        :key="tag.value"
                      >
                        <span class="tagClass1" @click="tagClick(tag.value)">{{ tag.value }}</span>
                      </div> -->
                      <br>
                      <br>
                      <span>Review*</span>
                      <br>
                      <input id="gradeReview" type="text" name="Review" placeholder="" />
                      <br>
                      <br>
                      <br>
                      <span>To encourage customers to leave a review, we will send some of the lucky customers who leave the review a surprise bonus or cash reward</span>
                      <br>
                      <button type="button" @click="fromSubmit">SUBMIT</button>
                      <div class="after-contact-box" v-if="showAfterBox">
                        <p>How can we help?</p>
                        <p>Call: +1909-391-3888</p>
                        <p>Email: help@1byone.com</p>
                      </div>
                    </form>
                  </div>
                </div>

                <!-- 分享 -->
                <div class="box-right-form share" v-if="showBoxShare">
                  <h4>Thank you for your support! </h4>
                  <!-- <h4>You are almost done! </h4>
                  <br>
                  <span>We've got your review. And we will appreciate it if you are willing to share your sincere comments on Amazon. Your reviews create value and make a huge difference for other customers and us! </span>
                  <br>
                  <div @click="finishedInvited()">
                    <img border="0" src="../../assets/share.png" width="281" height="61"/>
                  </div> -->
               </div>


                <div class="box-right-form contact" v-if="showboxContact">
                  <span>We've got your review,but we're not satisfied when any of our customers feel that way,We want to fix the problem,or replace your product for free</span>
                  <br>
                    <form action="..." method="post" id="contact">
                       <br>
                        <span>Message*</span>
                         <br>
                        <input id="contactMessage" type="text" name="message" placeholder="" />
                        <br>
                        <br>
                        
                        <br>
                        <input id="contactFirstName" type="text" name="FirstName" placeholder="FirstName*" />
                        <input id="contactLastName" type="text" name="LastName" placeholder="LastName*" />
                        <br>
                        <br>
                        <input id="contactEmail" type="text" name="email" placeholder="Email*" />
                        <br>
                        <br>
                        <br>
                        <br>
                        <button type="button" @click="contactfrom">SUBMIT</button>
                        <button type="button" @click="NoThanks">No Thanks</button>
                        </form>
               </div>

                <div class="box-right-form received" v-if="showReceived">
                  <div>
                  <span>We have received your feedback and will contact</span>
                  <br>
                  <br>
                  <span>you as soon as possible.</span>
                  <br>
                  <div class="clickclose" @click="NoThanks">close</div>
                </div>

                
               </div>


              

               </div>
          </div>
              
        </transition>
      </div>



      <router-link :to="getYourAccountUrl()" v-if="isYourAccountEnabled">
        <div class="menu-item nav-item icon-sprite nav-icon nav-icon-account"></div>
      </router-link>
      <div class="mx-4" @click="taggleSearchBar" ref="searchButton">
        <div class="menu-item nav-item icon-sprite nav-icon nav-icon-search"></div>
      </div>
    </div>
    <transition name="fade">
      <search-bar v-show="showSearchBar"></search-bar>
    </transition>
    <transition name="slide-fade">
      <div
        id="onebyone-nav-content-overlay"
        class="nav-overlay"
        @mousemove="showNavOverlay"
        @mouseleave="hideNavOverlay"
        v-show="showNavContentOverlay"
      >
        <div
          v-if="overlayContentSubject == 'product'"
          id="product-category"
          class="d-flex justify-center"
        >
          <div
            class="sub-nav-content"
            v-for="(category, index) in overlayContent.subMenu"
            :key="index"
          >
            <div class="category-title text-uppercase">{{ category.name }}</div>
            <div
              class="category-item font-size-14 nav-item-link nav-subitem-hover"
              v-for="(subCategory, index) in category.subCategory"
              :key="index"
            >
              <a :href="subCategory.landingPage">{{ subCategory.name }}</a>
            </div>
            <div
              id="nav-view-all-product"
              v-if="category.name == 'Healthy Life'"
              class="text-uppercase nav-item-link"
            >
              <a href="/product/browse">View all product ></a></br></br>
              <a href="/product/download">Download APP ></a>
            </div>
          </div>
        </div>
        <div
          v-else-if="overlayContentSubject == 'support'"
          id="support-category"
          class="d-flex justify-space-around mx-auto align-center"
        >
          <div
            class="support-subject-container pa-3"
            v-for="(supportSubject, index) in overlayContent.subMenu"
            :key="index"
          >
            <router-link :to="supportSubject.landingPage">
              <div
                class="support-subject text-uppercase pl-2 nav-subitem-hover"
              >{{ supportSubject.name}}</div>
            </router-link>
          </div>
        </div>
      </div>
    </transition>
    <div id="onebyone-my-account-overlay" class="nav-overlay"></div>

    <subDialog v-show="dialog_visible"></subDialog>
  </div>
</template>>

<script>
import { getImage } from "../../api/dataFactory";
import navBarMixins from "../../mixins/navBarMixins";
import SearchBar from "./SearchBar";
import { mapState, mapMutations } from "vuex";
import subDialog from "./Comment";
import dialog from "../../assets/dialog.png";
import dialog_red from "../../assets/dialog_red.png";
import fullStar from "../../assets/fullStar.png";
import hollowStar from "../../assets/hollowStar.png";
import bus from "../../api/bus";
import { defaultAxiosConfig } from "../../api/apiConfig";
import contactUsImg from "../../assets/f1.png";
import A01 from "../../assets/A01.png";
import A02 from "../../assets/A02.jpg";
import A03 from "../../assets/A03.jpg";
import A05 from "../../assets/A05.jpg";
import A06 from "../../assets/A06.jpg";
import A07 from "../../assets/A07.jpg";
import A08 from "../../assets/A08.jpg";
import A09 from "../../assets/A09.jpg";
import A10 from "../../assets/A10.jpg";
import A11 from "../../assets/A11.jpg";
import A12 from "../../assets/A12.jpg";
import B01 from "../../assets/B01.jpg";
import B02 from "../../assets/B02.jpg";
import B03 from "../../assets/B03.jpg";
import B04 from "../../assets/B04.png";
import B05 from "../../assets/B05.png";
import B06 from "../../assets/B06.png";
import B08 from "../../assets/B08.jpg";
import D01 from "../../assets/D01.png";
import E01 from "../../assets/E01.png";
import W01 from "../../assets/W01.jpg";
import W02 from "../../assets/W02.jpg";
import WN1 from "../../assets/WN1.png";
import T01 from "../../assets/T01.jpg";
import ptheise from "../../assets/ptheise.png";
import tizhihei from "../../assets/tizhihei.png";
import itohei from "../../assets/itohei.png";
import itobai from "../../assets/itobai.png";

export default {
  mixins: [navBarMixins],
  components: {
    SearchBar,
    subDialog,
  },
  data: () => ({
    imgSrc: dialog,
    sp_img: contactUsImg,
    spUrl: "https://www.amazon.com/review/create-review?&asin=B07FXTB52B:5",
    spId: "B07XRCHY2J",
    starNum: 0,
    getImage,
    asinRegion: "US",
    radioVal: "UK",
    twoDiv: false,
    showBoxText: true,
    selectEU: false,
    showBoxCUright: true,
    showBoxAmazon: false,
    showBoxForm: false,
    showRightForm: true,
    showBoxGrade: false,
    showBoxShare: false,
    showBoxCU: true,
    showBox: false,
    showAfterBox: false,
    showboxContact: true,
    showloginsuccessful: true,
    showReceived: false,
    showSelectProduct: true,

    isClick: false,

    star1: hollowStar,
    star2: hollowStar,
    star3: hollowStar,
    star4: hollowStar,
    star5: hollowStar,

    showNavContentOverlay: false,
    overlayContentSubject: "product",
    overlayContent: "",
    dialog_visible: false,
    isYourAccountEnabled: false,

    tags: null,

    //产品评价标签
    A03tags: [
      {
        value: "Works well",
      },
      {
        value: "Great value and useful",
      },
      {
        value: "Good buy",
      },
      {
        value: "Accurate and consistent",
      },
      {
        value: "Worth the money",
      },
      {
        value: "Great scale",
      },
    ],

    A09tags: [
      {
        value: "Works well",
      },
      {
        value: "Great value and useful",
      },
      {
        value: "Good buy",
      },
      {
        value: "Accurate and consistent",
      },
      {
        value: "Worth the money",
      },
      {
        value: "Great scale",
      },
    ],

    menus: [
      {
        tag: "home",
        name: "Home",
        landingPage: "/",
      },
      {
        tag: "product",
        name: "Product and Support",
        page: "products",
        showOverlay: true,
        subMenu: [
          {
            name: "Healthy Life",
            subCategory: [
              {
                name: "Scales",
                // landingPage: "/product?c=health&sc=scale",
                landingPage: "/product/browse?c=health&sc=scale",
              },
              {
                name: "Bottle",
                // landingPage: "/product?c=health&sc=scale",
                landingPage: "/product/browse?c=health&sc=bottle",
              },
              {
                name: "Oximeter",
                landingPage: "/product/browse?c=health&sc=oximeter",
              },
              {
                name: "Blood Pressure Monitor",
                landingPage: "/product/browse?c=health&sc=bloodPressureMonitor",
              },
              {
                name: "ECG Monitor",
                landingPage: "/product/browse?c=health&sc=ecgMonitor",
              },
              {
                name: "TENS",
                landingPage: "/product/browse?c=health&sc=tens",
              },{
                name: "White Noise Machine",
                landingPage: "/product/browse?c=health&sc=whitenoiseMachine",
              },{
                name: "Resistance Band",
                landingPage: "/product/browse?c=health&sc=resistanceBand",
              },
            ],
          },
        ],
      },

      {
        tag: "about_us",
        name: "About Us",
        landingPage: "/support/about_us/",
      },
    ],
  }),

  created: function () {
    // this.Homebox();
    this.Grade();
    this.CU();
    this.Guide();
    this.EnterGuide();
    this.Share();
  },

  mounted() {
    this.starClick(5);
    window.showdengluchenggong = this.showdengluchenggong; // 方法赋值给window
  },
  methods: {
    redicetGrand() {
      this.showxingjipl();
    },
    NoThanks() {
      this.boxclear();
    },

    contactfrom() {
      var contactMessage = document.getElementById("contactMessage").value;
      var contactFirstName = document.getElementById("contactFirstName").value;
      var contactLastName = document.getElementById("contactLastName").value;
      var contactEmail = document.getElementById("contactEmail").value;
      var istrue = false;
      if (contactMessage == "") {
        document.getElementById("contactMessage").style.border =
          "1px solid red";
        istrue = false;
      } else {
        istrue = true;
      }

      if (contactFirstName == "") {
        document.getElementById("contactFirstName").style.border =
          "1px solid red";
        istrue = false;
      } else {
        document.getElementById("contactFirstName").style.border = "none";
        istrue = true;
      }

      if (contactLastName == "") {
        document.getElementById("contactLastName").style.border =
          "1px solid red";
        istrue = false;
      } else {
        document.getElementById("contactLastName").style.border = "none";
        istrue = true;
      }

      if (contactEmail == "") {
        document.getElementById("contactEmail").style.border = "1px solid red";
        istrue = false;
      } else {
        istrue = true;
      }

      if (!this.checkEmail(contactEmail)) {
        document.getElementById("contactEmail").style.border = "1px solid red";
        istrue = false;
      } else {
        istrue = true;
      }

      if (istrue) {
        this.$axios({
          url: defaultAxiosConfig.baseURL + "/ap/warranty",

          method: "post",
          params: {
            message: contactMessage,
            fristName: contactFirstName,
            lastName: contactLastName,
            email: contactEmail,
          },
        }).then((res) => {
          console.log(res);
        });
        this.showfankuichenggong();
      }
    },

    tagClick(value) {
      if (document.getElementById("gradeReview").value == "") {
        document.getElementById("gradeReview").value = value;
      } else {
        document.getElementById("gradeReview").value += "," + value;
      }
    },

    // 其他表单的提交
    checkBoxFrom(type) {
      var fristName;
      var email;
      var updateEmail;
      var purchaseWays;
      var ordernumber;
      var uploadOrder;

      if (type == 1) {
        fristName = document.getElementById("purchaseWaysName").value;
        email = document.getElementById("purchaseWaysEmail").value;
        ordernumber = "";
        purchaseWays = document.getElementById("purchaseWays").value;
      } else {
        fristName = document.getElementById("fristName").value;
        email = document.getElementById("email").value;
        ordernumber =
          document.getElementById("ordernumber1").value +
          "-" +
          document.getElementById("ordernumber2").value +
          "-" +
          document.getElementById("ordernumber3").value;
        purchaseWays = "Amazon " + sessionStorage.getItem("asinRegion");
      }

      if (
        sessionStorage.getItem("emailString") != null &&
        sessionStorage.getItem("emailString") != ""
      ) {
        uploadOrder = "2";
        updateEmail = sessionStorage.getItem("emailString");
      }

      var istrue = true;
      if (fristName == "") {
        document.getElementById("fristName").style.border = "1px solid red";
        document.getElementById("affrim").style.color = "red";
        istrue = false;
      } else {
        istrue = true;
      }
      if (email == "") {
        document.getElementById("email").style.border = "1px solid red";
        istrue = false;
      } else {
        istrue = true;
      }

      var country;
      if (sessionStorage.getItem("asinRegion") == "EU") {
        country = this.radioVal;
      } else {
        country = sessionStorage.getItem("asinRegion");
      }

      if (istrue) {
        this.$axios({
          url: defaultAxiosConfig.baseURL + "/ap/warranty",
          method: "post",
          params: {
            fristName: fristName,
            email: email,
            orderNumber: ordernumber,
            orderPurchaseWays: country,
            product_id: this.spId,
            uploadOrder: uploadOrder,
            updateEmail: updateEmail,
            entrance: "pc",
          },
        }).then((res) => {
          console.log(res);
        });

        sessionStorage.setItem("fristName", fristName);
        sessionStorage.setItem("email", email);
        return true;
      } else {
        return false;
      }
    },

    // 星级评分的提交
    fromSubmit() {
      var gradeReview = document.getElementById("gradeReview").value;
      var name;
      var email;
      var uploadOrder;
      if (sessionStorage.getItem("warrantyState") != "1") {
        name = "";
        email = "无邮箱" + this.randomString(10);
        sessionStorage.setItem("emailString", email);
        uploadOrder = "2";
      } else {
        name = sessionStorage.getItem("firstName");
        email = sessionStorage.getItem("email");
        uploadOrder = "1";
      }

      var country;
      if (sessionStorage.getItem("asinRegion") == "EU") {
        country = this.radioVal;
      } else {
        country = sessionStorage.getItem("asinRegion");
      }

      var istrue = true;

      if (this.starNum == 0) {
        document.getElementById("starMobile").style.border = "1px solid red";
        istrue = false;
        return;
      }

      if (this.starNum <= 3) {
        if (gradeReview == "" || gradeReview == null) {
          document.getElementById("gradeReview").style.border = "1px solid red";
          istrue = false;
          return;
        } else {
          istrue = true;
        }
      } else {
        istrue = true;
      }

      if (istrue) {
        this.$axios({
          url: defaultAxiosConfig.baseURL + "/ap/comment",
          //     url: "http://localhost:5000/ap/comment",
          method: "post",
          params: {
            product_id: this.spId,
            score: this.starNum,
            review: gradeReview,
            name: name,
            email: email,
            country: country,
            uploadOrder: uploadOrder,
          },
        }).then((res) => {
          sessionStorage.removeItem("reviewState");
          sessionStorage.setItem("reviewState", "1");
          console.log(res);
        });
        if (this.starNum > 3) {
          //  let text = document.getElementById('gradeReview');
          // text.select();
          // document.execCommand('Copy');

          if (sessionStorage.getItem("warrantyState") != "1") {
            sessionStorage.removeItem("warrantyState");
            sessionStorage.setItem("warrantyState", "0");
            sessionStorage.removeItem("reviewState");
            sessionStorage.setItem("reviewState", "1");
            this.showyingdao();
            return;
          } else {
            this.showfengxiang();
          }
        } else {
          sessionStorage.removeItem("reviewState");
          sessionStorage.setItem("reviewState", "1");
          if (sessionStorage.getItem("warrantyState") != "1") {
            sessionStorage.removeItem("warrantyState");
            sessionStorage.setItem("warrantyState", "0");
            this.showyingdao();
            return;
          } else {
            this.showlianxiwomeng();
          }
        }
      }
    },

    // 联系我们的提交
    fromChoose() {
      var selectproduct = this.spId;
      var Message = document.getElementById("selectMessage").value;
      var selectFirstName = document.getElementById("selectFirstName").value;
      var selectLastName = document.getElementById("selectLastName").value;
      var email = document.getElementById("selectEmail").value;

      var country;
      if (sessionStorage.getItem("asinRegion") == "EU") {
        country = this.radioVal;
      } else {
        country = sessionStorage.getItem("asinRegion");
      }

      var istrue = true;
      if (Message == "") {
        document.getElementById("selectMessage").style.border = "1px solid red";
        istrue = false;
      } else {
        istrue = true;
      }
      if (selectFirstName == "") {
        document.getElementById("selectFirstName").style.border =
          "1px solid red";
        istrue = false;
      } else {
        istrue = true;
      }
      if (selectLastName == "") {
        document.getElementById("selectLastName").style.border =
          "1px solid red";
        istrue = false;
      } else {
        istrue = true;
      }
      if (email == "") {
        document.getElementById("selectEmail").style.border = "1px solid red";
        istrue = false;
      } else {
        istrue = true;
      }
      if (!this.checkEmail(email)) {
        document.getElementById("selectEmail").style.border = "1px solid red";
        istrue = false;
      } else {
        istrue = true;
      }

      if (istrue) {
        this.$axios({
          url: defaultAxiosConfig.baseURL + "/ap/cu",
          //  url: "http://localhost:5000/ap/cu",
          method: "post",
          params: {
            product_id: selectproduct,
            message: Message,
            firstName: selectFirstName,
            lastName: selectLastName,
            email: email,
            country: country,
          },
        }).then((res) => {
          console.log(res);
        });
        this.showfankuichenggong();
      }
    },

    randomString(len) {
      len = len || 32;
      var $chars =
        "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678"; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
      var maxPos = $chars.length;
      var pwd = "";
      for (var i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },

    //  兄弟传值
    Grade: function () {
      bus.$on("showBoxGrade", (message) => {
        this.chooseSP(message);
        this.showxingjipl();
      });
    },

    CU: function () {
      bus.$on("showBoxCU", (message) => {
        this.showSelectProduct = false;
        this.chooseSP(message);
        this.showlianxiwomeng();
      });
    },
    Guide: function () {
      bus.$on("showBoxGuide", (message) => {
        this.showyingdao();
      });
    },
    EnterGuide: function () {
      bus.$on("entershowBoxGuide", (message) => {
        this.selectEU = false;
        this.chooseSP(message);
        this.showyingdao();
      });
    },
    Homebox: function () {
      bus.$on("showHomebox", (message) => {
        if (message) {
          this.chooseSP(sessionStorage.getItem("pid"));
          this.showxingjipl();
        } else {
          this.showlianxiwomeng();
        }
      });
    },
    Share: function () {
      bus.$on("showBoxShare", (message) => {
        this.chooseSP(message);
        this.showfengxiang();
      });
    },

    // 星星移入移出效果
    mouseOver(num) {
      if (num == 1) {
        this.star1 = fullStar;
      } else if (num == 2) {
        this.star1 = fullStar;
        this.star2 = fullStar;
      } else if (num == 3) {
        this.star1 = fullStar;
        this.star2 = fullStar;
        this.star3 = fullStar;
      } else if (num == 4) {
        this.star1 = fullStar;
        this.star2 = fullStar;
        this.star3 = fullStar;
        this.star4 = fullStar;
      } else {
        this.star1 = fullStar;
        this.star2 = fullStar;
        this.star3 = fullStar;
        this.star4 = fullStar;
        this.star5 = fullStar;
      }
    },

    mouseLeave() {
      if (this.isClick == false) {
        this.star1 = hollowStar;
        this.star2 = hollowStar;
        this.star3 = hollowStar;
        this.star4 = hollowStar;
        this.star5 = hollowStar;
      } else {
        if (this.starNum == 1) {
          this.star2 = hollowStar;
          this.star3 = hollowStar;
          this.star4 = hollowStar;
          this.star5 = hollowStar;
        } else if (this.starNum == 2) {
          this.star3 = hollowStar;
          this.star4 = hollowStar;
          this.star5 = hollowStar;
        } else if (this.starNum == 3) {
          this.star4 = hollowStar;
          this.star5 = hollowStar;
        } else if (this.starNum == 4) {
          this.star5 = hollowStar;
        }
      }
    },
    starClick(num) {
      this.isClick = true;
      this.starNum = num;
      if (this.starnum != 5) {
        this.showAfterBox = true;
      }

      if (num == 1) {
        this.star1 = fullStar;
        this.star2 = hollowStar;
        this.star3 = hollowStar;
        this.star4 = hollowStar;
        this.star5 = hollowStar;
      } else if (num == 2) {
        this.star1 = fullStar;
        this.star2 = fullStar;
        this.star3 = hollowStar;
        this.star4 = hollowStar;
        this.star5 = hollowStar;
      } else if (num == 3) {
        this.star1 = fullStar;
        this.star2 = fullStar;
        this.star3 = fullStar;
        this.star4 = hollowStar;
        this.star5 = hollowStar;
      } else if (num == 4) {
        this.star1 = fullStar;
        this.star2 = fullStar;
        this.star3 = fullStar;
        this.star4 = fullStar;
        this.star5 = hollowStar;
      } else if (num == 5) {
        this.star1 = fullStar;
        this.star2 = fullStar;
        this.star3 = fullStar;
        this.star4 = fullStar;
        this.star5 = fullStar;
        this.showAfterBox = false;
      }
    },

    getItemData(showxingjipla) {
      amazon.Login.setClientId(
        "amzn1.application-oa2-client.614ad24b739447b5bf9ccb4412388215"
      );
      var options = { scope: "profile", response_type: "code", pkce: true };
      amazon.Login.authorize(options, function (response) {
        if (response.error) {
          alert("oauth error " + response.error);
          return;
        }

        console.info("code: " + response.code);

        amazon.Login.retrieveToken(response.code, function (response) {
          if (response.error) {
            alert("oauth error " + response.error);
            return;
          }

          console.info("Access Token: " + response.access_token);

          amazon.Login.retrieveProfile(
            response.access_token,
            function (response) {
              sessionStorage.setItem("name", response.profile.Name);
              sessionStorage.setItem(
                "amazonUserinfo",
                JSON.stringify(response)
              );
              showdengluchenggong();
            }
          );
        });
      });
      //  this.showdengluchenggong();
    },

    // 动态控制气泡框
    showDetaile() {
      // 显示不同值
      this.showBox = !this.showBox;
      if (this.showBox) {
        this.showlianxiwomeng();

        this.imgSrc = dialog;
      } else {
        this.boxclear();
        this.imgSrc = dialog_red;
      }
    },
    ...mapMutations("nav", {
      taggleSearchBar: "TAGGLE_SEARCH_BAR",
    }),

    showDialog(visible) {
      this.dialog_visible = visible;
    },
    changeChannel() {
      let ccId = document.getElementById("cc").value;
      if (ccId == "amazon-US") {
        this.asinRegion = "US";
        this.selectEU = false;
        sessionStorage.removeItem("asinRegion");
        sessionStorage.setItem("asinRegion", "US");
        this.showyamaxun();
      } else if (ccId == "amazon-CA") {
        this.asinRegion = "CA";
        this.selectEU = false;
        sessionStorage.removeItem("asinRegion");
        sessionStorage.setItem("asinRegion", "CA");
        this.showyamaxun();
      } else if (ccId == "amazon-EU") {
        this.asinRegion = "EU";
        sessionStorage.removeItem("asinRegion");
        sessionStorage.setItem("asinRegion", "EU");
        this.showyamaxun();
        this.selectEU = true;
      } else if (ccId == "comment") {
        this.showxingjipl();
      } else if (ccId == "share") {
        this.showfengxiang();
      } else {
        this.showqitafrom();
      }
    },

    //   显示各种盒子方法
    showyamaxun() {
      this.boxclear();
      this.showBox = true;
      this.twoDiv = true;
      this.showRightForm = true;
      this.showBoxAmazon = true;

      //  this. showdengluchenggong();
    },
    showdengluchenggong() {
      this.boxclear();
      this.showBox = true;
      this.twoDiv = true;
      this.showloginsuccessful = true;
    },

    showfengxiang() {
      this.boxclear();
      this.showBox = true;
      this.showBoxCU = true;
      this.showBoxShare = true;
    },

    showqitafrom() {
      this.boxclear();
      this.showBoxForm = true;
      this.showBox = true;
      this.twoDiv = true;
      this.showRightForm = true;
    },

    showxingjipl() {
      this.boxclear();
      this.showBoxGrade = true;
      this.showBox = true;
      this.showBoxCU = true;
      // this.showBox = true;
      // this.showBoxCU=true;
      // this.showboxContact=true;
    },

    showlianxiwomeng() {
      this.boxclear();
      this.showBox = true;
      this.showBoxCU = true;
      this.showBoxCUright = true;
    },

    showyingdao() {
      this.boxclear();
      this.showBoxText = true;
      this.showBox = true;
      this.twoDiv = true;
      this.showRightForm = true;
    },

    show3xinglianxi() {
      this.boxclear();
      this.showBox = true;
      this.showBoxCU = true;
      this.showboxContact = true;
    },
    showfankuichenggong() {
      this.boxclear();
      this.showBox = true;
      this.showBoxCU = true;
      this.showReceived = true;
    },
    // 清空盒子
    boxclear() {
      (this.twoDiv = false),
        (this.showBoxText = false),
        (this.showBoxCUright = false),
        (this.showBoxAmazon = false),
        (this.showBoxForm = false),
        (this.showRightForm = false),
        (this.showBoxGrade = false),
        (this.showBoxShare = false),
        (this.showBoxCU = false),
        (this.showBox = false),
        (this.showboxContact = false),
        (this.showloginsuccessful = false),
        (this.showReceived = false),
        (this.selectEU = false);
    },

    closeBox() {
      this.boxclear();
    },

    affrimRecord(type) {
      if (this.checkBoxFrom(type) == true) {
        sessionStorage.removeItem("warrantyState");
        sessionStorage.setItem("warrantyState", "1");

        if (sessionStorage.getItem("reviewState") != "1") {
          this.chooseSP(this.spId);
          this.showdengluchenggong();
        } else {
          this.chooseSP(this.spId);
          if (this.starNum > 3) {
            sessionStorage.removeItem("reviewState");
            this.showfengxiang();
          } else {
            sessionStorage.removeItem("reviewState");
            this.showlianxiwomeng();
          }
        }
      }
    },

    finishedInvited() {
      if (sessionStorage.getItem("warrantyState") != "1") {
        this.showyingdao();
        this.showMenuIcon();
        return;
      }

      if (sessionStorage.getItem("reviewState") != "1") {
        this.showxingjipl();
        this.showMenuIcon();
        return;
      }
      window.open(this.spUrl);
      sessionStorage.removeItem("invitedState");
      sessionStorage.setItem("invitedState", "1");
      this.showMenuIcon();
      this.invitedchenggong();
    },

    transfer(box) {
      if (box == 1) {
        var text1 = document.getElementById("ordernumber1").value;
        if (text1.length == 3) {
          document.getElementById("ordernumber2").focus();
        }
      } else {
        var text2 = document.getElementById("ordernumber2").value;
        if (text2.length == 7) {
          document.getElementById("ordernumber3").focus();
        }
      }
    },

    changeSp() {
      let spId = document.getElementById("sp").value;
      this.chooseSP(spId);
    },
    //  根据spid图片，跟植入asin值
    chooseSP(spId) {
      if (spId == "A01") {
        this.spId = "A01";
        this.sp_img = A01;
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl =
            "https://www.amazon.com/review/create-review?&asin=B07FXTB52B:5";
        if (sessionStorage.getItem("asinRegion") == "CA")
          this.spUrl =
            "https://www.amazon.ca/review/create-review?&asin=B07TLW4FSB:5";
        if (sessionStorage.getItem("asinRegion") == "EU") {
          if (this.radioVal == "UK") {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B07FXTB52B:5";
          } else if (this.radioVal == "DE") {
            this.spUrl =
              "https://www.amazon.de/review/create-review?&asin=B07FXTB52B:5";
          } else if (this.radioVal == "FR") {
            this.spUrl =
              "https://www.amazon.fr/review/create-review?&asin=B07FXTB52B:5";
          } else if (this.radioVal == "IT") {
            this.spUrl =
              "https://www.amazon.it/review/create-review?&asin=B07FXTB52B:5";
          } else if (this.radioVal == "ES") {
            this.spUrl =
              "https://www.amazon.es/review/create-review?&asin=B07FXTB52B:5";
          } else {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B07FXTB52B:5";
          }
        }
      } else if (spId == "A02") {
        this.spId = "A02";
        this.sp_img = A02;
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl =
            "https://www.amazon.com/review/create-review?&asin=B07WK1V886:5";
        if (sessionStorage.getItem("asinRegion") == "CA")
          this.spUrl =
            "https://www.amazon.ca/review/create-review?&asin=B081GYJ99R:5";
        if (sessionStorage.getItem("asinRegion") == "EU") {
          if (this.radioVal == "UK") {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B07WMTH6MT:5";
          } else if (this.radioVal == "DE") {
            this.spUrl =
              "https://www.amazon.de/review/create-review?&asin=B07WMTH6MT:5";
          } else if (this.radioVal == "FR") {
            this.spUrl =
              "https://www.amazon.fr/review/create-review?&asin=B07WMTH6MT:5";
          } else if (this.radioVal == "IT") {
            this.spUrl =
              "https://www.amazon.it/review/create-review?&asin=B07WMTH6MT:5";
          } else if (this.radioVal == "ES") {
            this.spUrl =
              "https://www.amazon.es/review/create-review?&asin=B07WMTH6MT:5";
          } else {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B07WMTH6MT:5";
          }
        }
      } else if (spId == "A03") {
        this.spId = "A03";
        this.sp_img = A03;
        this.tags = this.A03tags;
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl =
            "https://www.amazon.com/review/create-review?&asin=B08D6BJL71:5";
        if (sessionStorage.getItem("asinRegion") == "CA")
          this.spUrl =
            "https://www.amazon.ca/review/create-review?&asin=B08D6BJL71:5";
        if (sessionStorage.getItem("asinRegion") == "EU") {
          if (this.radioVal == "UK") {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B089SZG65L:5";
          } else if (this.radioVal == "DE") {
            this.spUrl =
              "https://www.amazon.de/review/create-review?&asin=B089SZG65L:5";
          } else if (this.radioVal == "FR") {
            this.spUrl =
              "https://www.amazon.fr/review/create-review?&asin=B089SZG65L:5";
          } else if (this.radioVal == "IT") {
            this.spUrl =
              "https://www.amazon.it/review/create-review?&asin=B089SZG65L:5";
          } else if (this.radioVal == "ES") {
            this.spUrl =
              "https://www.amazon.es/review/create-review?&asin=B089SZG65L:5";
          } else {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B089SZG65L:5";
          }
        }
      } else if (spId == "A04") {
        this.spId = "A04";
        this.sp_img = A02;
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl =
            "https://www.amazon.com/review/create-review?&asin=B08FQTXDKV:5";
        if (sessionStorage.getItem("asinRegion") == "CA")
          this.spUrl =
            "https://www.amazon.ca/review/create-review?&asin=B08FQTXDKV:5";
        if (sessionStorage.getItem("asinRegion") == "EU") {
          if (this.radioVal == "UK") {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B08FQTXDKV:5";
          } else if (this.radioVal == "DE") {
            this.spUrl =
              "https://www.amazon.de/review/create-review?&asin=B08FQTXDKV:5";
          } else if (this.radioVal == "FR") {
            this.spUrl =
              "https://www.amazon.fr/review/create-review?&asin=B08FQTXDKV:5";
          } else if (this.radioVal == "IT") {
            this.spUrl =
              "https://www.amazon.it/review/create-review?&asin=B08FQTXDKV:5";
          } else if (this.radioVal == "ES") {
            this.spUrl =
              "https://www.amazon.es/review/create-review?&asin=B08FQTXDKV:5";
          } else {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B08FQTXDKV:5";
          }
        }
      } else if (spId == "A05") {
        this.spId = "A05";
        this.sp_img = A05;
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl =
            "https://www.amazon.com/review/create-review?&asin=B082W5Y6QP:5";
        if (sessionStorage.getItem("asinRegion") == "CA")
          this.spUrl =
            "https://www.amazon.ca/review/create-review?&asin=B01FHELB56:5";
        if (sessionStorage.getItem("asinRegion") == "EU") {
          if (this.radioVal == "UK") {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B07FFSYQDM:5";
          } else if (this.radioVal == "DE") {
            this.spUrl =
              "https://www.amazon.de/review/create-review?&asin=B07FFSYQDM:5";
          } else if (this.radioVal == "FR") {
            this.spUrl =
              "https://www.amazon.fr/review/create-review?&asin=B07FFSYQDM:5";
          } else if (this.radioVal == "IT") {
            this.spUrl =
              "https://www.amazon.it/review/create-review?&asin=B07FFSYQDM:5";
          } else if (this.radioVal == "ES") {
            this.spUrl =
              "https://www.amazon.es/review/create-review?&asin=B07FFSYQDM:5";
          } else {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B07FFSYQDM:5";
          }
        }
      } else if (spId == "A06") {
        this.spId = "A06";
        this.sp_img = A06;
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl =
            "https://www.amazon.com/review/create-review?&asin=B0852DHR53:5";
        if (sessionStorage.getItem("asinRegion") == "CA")
          this.spUrl =
            "https://www.amazon.ca/review/create-review?&asin=B07TJS77KR:5";
        if (sessionStorage.getItem("asinRegion") == "EU") {
          if (this.radioVal == "UK") {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B07FFQ7685:5";
          } else if (this.radioVal == "DE") {
            this.spUrl =
              "https://www.amazon.de/review/create-review?&asin=B07FFQ7685:5";
          } else if (this.radioVal == "FR") {
            this.spUrl =
              "https://www.amazon.fr/review/create-review?&asin=B07FFQ7685:5";
          } else if (this.radioVal == "IT") {
            this.spUrl =
              "https://www.amazon.it/review/create-review?&asin=B07FFQ7685:5";
          } else if (this.radioVal == "ES") {
            this.spUrl =
              "https://www.amazon.es/review/create-review?&asin=B07FFQ7685:5";
          } else {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B07FFQ7685:5";
          }
        }
      } else if (spId == "A07") {
        this.spId = "A07";
        this.sp_img = A07;
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl =
            "https://www.amazon.com/review/create-review?&asin=B07XRG2SJR:5";
        if (sessionStorage.getItem("asinRegion") == "CA")
          this.spUrl =
            "https://www.amazon.ca/review/create-review?&asin=B07XRG2SJR:5";
        if (sessionStorage.getItem("asinRegion") == "EU") {
          if (this.radioVal == "UK") {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B07P6BPHRW:5";
          } else if (this.radioVal == "DE") {
            this.spUrl =
              "https://www.amazon.de/review/create-review?&asin=B07P6BPHRW:5";
          } else if (this.radioVal == "FR") {
            this.spUrl =
              "https://www.amazon.fr/review/create-review?&asin=B07P6BPHRW:5";
          } else if (this.radioVal == "IT") {
            this.spUrl =
              "https://www.amazon.it/review/create-review?&asin=B07P6BPHRW:5";
          } else if (this.radioVal == "ES") {
            this.spUrl =
              "https://www.amazon.es/review/create-review?&asin=B07P6BPHRW:5";
          } else {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B07P6BPHRW:5";
          }
        }
      } else if (spId == "A08") {
        this.spId = "A08";
        this.sp_img = A08;
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl =
            "https://www.amazon.com/review/create-review?&asin=B07XRCHY2J:5";
        if (sessionStorage.getItem("asinRegion") == "CA")
          this.spUrl =
            "https://www.amazon.ca/review/create-review?&asin=B07XRCHY2J:5";
        if (sessionStorage.getItem("asinRegion") == "EU") {
          if (this.radioVal == "UK") {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B07XRHMZPC:5";
          } else if (this.radioVal == "DE") {
            this.spUrl =
              "https://www.amazon.de/review/create-review?&asin=B07XRHMZPC:5";
          } else if (this.radioVal == "FR") {
            this.spUrl =
              "https://www.amazon.fr/review/create-review?&asin=B07XRHMZPC:5";
          } else if (this.radioVal == "IT") {
            this.spUrl =
              "https://www.amazon.it/review/create-review?&asin=B07XRHMZPC:5";
          } else if (this.radioVal == "ES") {
            this.spUrl =
              "https://www.amazon.es/review/create-review?&asin=B07XRHMZPC:5";
          } else {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B07XRHMZPC:5";
          }
        }
      } else if (spId == "A09") {
        this.spId = "A09";
        this.sp_img = A09;
        this.tags = this.A09tags;
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl =
            "https://www.amazon.com/review/create-review?&asin=B08KG4YV5B:5";
        if (sessionStorage.getItem("asinRegion") == "CA")
          this.spUrl =
            "https://www.amazon.ca/review/create-review?&asin=B08KG4YV5B:5";
        if (sessionStorage.getItem("asinRegion") == "EU") {
          if (this.radioVal == "UK") {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B08KG4YV5B:5";
          } else if (this.radioVal == "DE") {
            this.spUrl =
              "https://www.amazon.de/review/create-review?&asin=B08KG4YV5B:5";
          } else if (this.radioVal == "FR") {
            this.spUrl =
              "https://www.amazon.fr/review/create-review?&asin=B08KG4YV5B:5";
          } else if (this.radioVal == "IT") {
            this.spUrl =
              "https://www.amazon.it/review/create-review?&asin=B08KG4YV5B:5";
          } else if (this.radioVal == "ES") {
            this.spUrl =
              "https://www.amazon.es/review/create-review?&asin=B08KG4YV5B:5";
          } else {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B08KG4YV5B:5";
          }
        }
      } else if (spId == "A10") {
        this.spId = "A10";
        this.sp_img = A10;
        this.tags = this.A09tags;
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl =
            "https://www.amazon.com/review/create-review?&asin=B08R6SL1WQ:5";
        if (sessionStorage.getItem("asinRegion") == "CA")
          this.spUrl =
            "https://www.amazon.ca/review/create-review?&asin=B08R6VHTZV:5";
        if (sessionStorage.getItem("asinRegion") == "EU") {
          if (this.radioVal == "UK") {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B08SC4C2YK:5";
          } else if (this.radioVal == "DE") {
            this.spUrl =
              "https://www.amazon.de/review/create-review?&asin=B089VPXBX6:5";
          } else if (this.radioVal == "FR") {
            this.spUrl =
              "https://www.amazon.fr/review/create-review?&asin=B089VPXBX6:5";
          } else if (this.radioVal == "IT") {
            this.spUrl =
              "https://www.amazon.it/review/create-review?&asin=B089VPXBX6:5";
          } else if (this.radioVal == "ES") {
            this.spUrl =
              "https://www.amazon.es/review/create-review?&asin=B089VPXBX6:5";
          } else {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B089VPXBX6:5";
          }
        }
      } else if (spId == "B01") {
        this.spId = "B01";
        this.sp_img = B01;
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl =
            "https://www.amazon.com/review/create-review?&asin=B08BC1DXHF:5";
        if (sessionStorage.getItem("asinRegion") == "CA")
          this.spUrl =
            "https://www.amazon.ca/review/create-review?&asin=B08BC1DXHF:5";
        if (sessionStorage.getItem("asinRegion") == "EU") {
          if (this.radioVal == "UK") {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B08BC1DXHF:5";
          } else if (this.radioVal == "DE") {
            this.spUrl =
              "https://www.amazon.de/review/create-review?&asin=B08BC1DXHF:5";
          } else if (this.radioVal == "FR") {
            this.spUrl =
              "https://www.amazon.fr/review/create-review?&asin=B08BC1DXHF:5";
          } else if (this.radioVal == "IT") {
            this.spUrl =
              "https://www.amazon.it/review/create-review?&asin=B08BC1DXHF:5";
          } else if (this.radioVal == "ES") {
            this.spUrl =
              "https://www.amazon.es/review/create-review?&asin=B08BC1DXHF:5";
          } else {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B08BC1DXHF:5";
          }
        }
      } else if (spId == "B02") {
        this.spId = "B02";
        this.sp_img = B02;
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl =
            "https://www.amazon.com/review/create-review?&asin=B08BF4RDWP:5";
        if (sessionStorage.getItem("asinRegion") == "CA")
          this.spUrl =
            "https://www.amazon.ca/review/create-review?&asin=B08BF4RDWP:5";
        if (sessionStorage.getItem("asinRegion") == "EU") {
          if (this.radioVal == "UK") {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B08BF4RDWP:5";
          } else if (this.radioVal == "DE") {
            this.spUrl =
              "https://www.amazon.de/review/create-review?&asin=B08BF4RDWP:5";
          } else if (this.radioVal == "FR") {
            this.spUrl =
              "https://www.amazon.fr/review/create-review?&asin=B08BF4RDWP:5";
          } else if (this.radioVal == "IT") {
            this.spUrl =
              "https://www.amazon.it/review/create-review?&asin=B08BF4RDWP:5";
          } else if (this.radioVal == "ES") {
            this.spUrl =
              "https://www.amazon.es/review/create-review?&asin=B08BF4RDWP:5";
          } else {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B08BF4RDWP:5";
          }
        }
      } else if (spId == "B03") {
        this.spId = "B03";
        this.sp_img = B03;
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl =
            "https://www.amazon.com/review/create-review?&asin=B089153D4W:5";
        if (sessionStorage.getItem("asinRegion") == "CA")
          this.spUrl =
            "https://www.amazon.ca/review/create-review?&asin=B089153D4W:5";
        if (sessionStorage.getItem("asinRegion") == "EU") {
          if (this.radioVal == "UK") {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B089153D4W:5";
          } else if (this.radioVal == "DE") {
            this.spUrl =
              "https://www.amazon.de/review/create-review?&asin=B089153D4W:5";
          } else if (this.radioVal == "FR") {
            this.spUrl =
              "https://www.amazon.fr/review/create-review?&asin=B089153D4W:5";
          } else if (this.radioVal == "IT") {
            this.spUrl =
              "https://www.amazon.it/review/create-review?&asin=B089153D4W:5";
          } else if (this.radioVal == "ES") {
            this.spUrl =
              "https://www.amazon.es/review/create-review?&asin=B089153D4W:5";
          } else {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B089153D4W:5";
          }
        }
      } else if (spId == "B04") {
        this.spId = "B04";
        this.sp_img = B04;
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl =
            "https://www.amazon.com/review/create-review?&asin=B089W7H9XK:5";
        if (sessionStorage.getItem("asinRegion") == "CA")
          this.spUrl =
            "https://www.amazon.ca/review/create-review?&asin=B089W7H9XK:5";
        if (sessionStorage.getItem("asinRegion") == "EU") {
          if (this.radioVal == "UK") {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B075DSY8BC:5";
          } else if (this.radioVal == "DE") {
            this.spUrl =
              "https://www.amazon.de/review/create-review?&asin=B075DSY8BC:5";
          } else if (this.radioVal == "FR") {
            this.spUrl =
              "https://www.amazon.fr/review/create-review?&asin=B075DSY8BC:5";
          } else if (this.radioVal == "IT") {
            this.spUrl =
              "https://www.amazon.it/review/create-review?&asin=B075DSY8BC:5";
          } else if (this.radioVal == "ES") {
            this.spUrl =
              "https://www.amazon.es/review/create-review?&asin=B075DSY8BC:5";
          } else {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B075DSY8BC:5";
          }
        }
      } else if (spId == "B05") {
        this.spId = "B05";
        this.sp_img = B05;
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl =
            "https://www.amazon.com/review/create-review?&asin=B07JG5JDD9:5";
        if (sessionStorage.getItem("asinRegion") == "CA")
          this.spUrl =
            "https://www.amazon.ca/review/create-review?&asin=B07JG5JDD9:5";
        if (sessionStorage.getItem("asinRegion") == "EU") {
          if (this.radioVal == "UK") {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B07JG5JDD9:5";
          } else if (this.radioVal == "DE") {
            this.spUrl =
              "https://www.amazon.de/review/create-review?&asin=B07JG5JDD9:5";
          } else if (this.radioVal == "FR") {
            this.spUrl =
              "https://www.amazon.fr/review/create-review?&asin=B07JG5JDD9:5";
          } else if (this.radioVal == "IT") {
            this.spUrl =
              "https://www.amazon.it/review/create-review?&asin=B07JG5JDD9:5";
          } else if (this.radioVal == "ES") {
            this.spUrl =
              "https://www.amazon.es/review/create-review?&asin=B07JG5JDD9:5";
          } else {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B07JG5JDD9:5";
          }
        }
      } else if (spId == "D01") {
        this.spId = "D01";
        this.sp_img = D01;
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl =
            "https://www.amazon.com/review/create-review?&asin=B082Y53TCQ:5";
        if (sessionStorage.getItem("asinRegion") == "CA")
          this.spUrl =
            "https://www.amazon.ca/review/create-review?&asin=B082Y53TCQ:5";
        if (sessionStorage.getItem("asinRegion") == "EU") {
          if (this.radioVal == "UK") {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B07ZVV561D:5";
          } else if (this.radioVal == "DE") {
            this.spUrl =
              "https://www.amazon.de/review/create-review?&asin=B07ZVV561D:5";
          } else if (this.radioVal == "FR") {
            this.spUrl =
              "https://www.amazon.fr/review/create-review?&asin=B07ZVV561D:5";
          } else if (this.radioVal == "IT") {
            this.spUrl =
              "https://www.amazon.it/review/create-review?&asin=B07ZVV561D:5";
          } else if (this.radioVal == "ES") {
            this.spUrl =
              "https://www.amazon.es/review/create-review?&asin=B07ZVV561D:5";
          } else {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B07ZVV561D:5";
          }
        }
      } else if (spId == "B06") {
        this.spId = "B06";
        this.sp_img = B06;
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl =
            "https://www.amazon.com/review/create-review?&asin=B07XTFW97H:5";
        if (sessionStorage.getItem("asinRegion") == "CA")
          this.spUrl =
            "https://www.amazon.ca/review/create-review?&asin=B07XTFW97H:5";
        if (sessionStorage.getItem("asinRegion") == "EU") {
          if (this.radioVal == "UK") {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B07XTFW97H:5";
          } else if (this.radioVal == "DE") {
            this.spUrl =
              "https://www.amazon.de/review/create-review?&asin=B07XTFW97H:5";
          } else if (this.radioVal == "FR") {
            this.spUrl =
              "https://www.amazon.fr/review/create-review?&asin=B07XTFW97H:5";
          } else if (this.radioVal == "IT") {
            this.spUrl =
              "https://www.amazon.it/review/create-review?&asin=B07XTFW97H:5";
          } else if (this.radioVal == "ES") {
            this.spUrl =
              "https://www.amazon.es/review/create-review?&asin=B07XTFW97H:5";
          } else {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B07XTFW97H:5";
          }
        }
      } else if (spId == "E01") {
        this.spId = "E01";
        this.sp_img = E01;
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl =
            "https://www.amazon.com/review/create-review?&asin=B082V7WB61:5";
        if (sessionStorage.getItem("asinRegion") == "CA")
          this.spUrl =
            "https://www.amazon.ca/review/create-review?&asin=B082V7WB61:5";
        if (sessionStorage.getItem("asinRegion") == "EU") {
          if (this.radioVal == "UK") {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B082V7WB61:5";
          } else if (this.radioVal == "DE") {
            this.spUrl =
              "https://www.amazon.de/review/create-review?&asin=B082V7WB61:5";
          } else if (this.radioVal == "FR") {
            this.spUrl =
              "https://www.amazon.fr/review/create-review?&asin=B082V7WB61:5";
          } else if (this.radioVal == "IT") {
            this.spUrl =
              "https://www.amazon.it/review/create-review?&asin=B082V7WB61:5";
          } else if (this.radioVal == "ES") {
            this.spUrl =
              "https://www.amazon.es/review/create-review?&asin=B082V7WB61:5";
          } else {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B082V7WB61:5";
          }
        }
      } else if (spId == "W01") {
        this.spId = "W01";
        this.sp_img = W01;
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl =
            "https://www.amazon.com/review/create-review?&asin=B08RN41KHF:5";
        if (sessionStorage.getItem("asinRegion") == "CA")
          this.spUrl =
            "https://www.amazon.ca/review/create-review?&asin=B08RMYSZRC:5";
        if (sessionStorage.getItem("asinRegion") == "EU") {
          if (this.radioVal == "UK") {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B08RNHP2KP:5";
          } else if (this.radioVal == "DE") {
            this.spUrl =
              "https://www.amazon.de/review/create-review?&asin=B08RNHP2KP:5";
          } else if (this.radioVal == "FR") {
            this.spUrl =
              "https://www.amazon.fr/review/create-review?&asin=B08RNHP2KP:5";
          } else if (this.radioVal == "IT") {
            this.spUrl =
              "https://www.amazon.it/review/create-review?&asin=B08RNHP2KP:5";
          } else if (this.radioVal == "ES") {
            this.spUrl =
              "https://www.amazon.es/review/create-review?&asin=B08RNHP2KP:5";
          } else {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B08RN41KHF:5";
          }
        }
      } else if (spId == "W02") {
        this.spId = "W02";
        this.sp_img = W02;
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl =
            "https://www.amazon.com/review/create-review?&asin=B08RNGJK7S:5";
        if (sessionStorage.getItem("asinRegion") == "CA")
          this.spUrl =
            "https://www.amazon.ca/review/create-review?&asin=B08RNGJK7S:5";
        if (sessionStorage.getItem("asinRegion") == "EU") {
          if (this.radioVal == "UK") {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B08RNGJK7S:5";
          } else if (this.radioVal == "DE") {
            this.spUrl =
              "https://www.amazon.de/review/create-review?&asin=B08RNGJK7S:5";
          } else if (this.radioVal == "FR") {
            this.spUrl =
              "https://www.amazon.fr/review/create-review?&asin=B08RNGJK7S:5";
          } else if (this.radioVal == "IT") {
            this.spUrl =
              "https://www.amazon.it/review/create-review?&asin=B08RNGJK7S:5";
          } else if (this.radioVal == "ES") {
            this.spUrl =
              "https://www.amazon.es/review/create-review?&asin=B08RNGJK7S:5";
          } else {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B08RNGJK7S:5";
          }
        }
      } else if (spId == "A11") {
        this.spId = "A11";
        this.sp_img = A11;
        let asin="B092LZMVP2";
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl =
            "https://www.amazon.com/review/create-review?&asin="+asin+":5";
        if (sessionStorage.getItem("asinRegion") == "CA")
          this.spUrl =
            "https://www.amazon.ca/review/create-review?&asin="+asin+":5";
        if (sessionStorage.getItem("asinRegion") == "EU") {
          if (this.radioVal == "UK") {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin="+asin+":5";
          } else if (this.radioVal == "DE") {
            this.spUrl =
              "https://www.amazon.de/review/create-review?&asin="+asin+":5";
          } else if (this.radioVal == "FR") {
            this.spUrl =
              "https://www.amazon.fr/review/create-review?&asin="+asin+":5";
          } else if (this.radioVal == "IT") {
            this.spUrl =
              "https://www.amazon.it/review/create-review?&asin="+asin+":5";
          } else if (this.radioVal == "ES") {
            this.spUrl =
              "https://www.amazon.es/review/create-review?&asin="+asin+":5";
          } else {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B08RN41KHF:5";
          }
        }
      } else if (spId == "A12") {
        this.spId = "A12";
        this.sp_img = A12;
        let asin="B092LZMVP2";
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl =
            "https://www.amazon.com/review/create-review?&asin="+asin+":5";
        if (sessionStorage.getItem("asinRegion") == "CA")
          this.spUrl =
            "https://www.amazon.ca/review/create-review?&asin="+asin+":5";
        if (sessionStorage.getItem("asinRegion") == "EU") {
          if (this.radioVal == "UK") {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin="+asin+":5";
          } else if (this.radioVal == "DE") {
            this.spUrl =
              "https://www.amazon.de/review/create-review?&asin="+asin+":5";
          } else if (this.radioVal == "FR") {
            this.spUrl =
              "https://www.amazon.fr/review/create-review?&asin="+asin+":5";
          } else if (this.radioVal == "IT") {
            this.spUrl =
              "https://www.amazon.it/review/create-review?&asin="+asin+":5";
          } else if (this.radioVal == "ES") {
            this.spUrl =
              "https://www.amazon.es/review/create-review?&asin="+asin+":5";
          } else {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B08RN41KHF:5";
          }
        }
      } else if (spId == "B08") {
        this.spId = "B08";
        this.sp_img = B08;
        let asin="B0923M3NDJ";
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl =
            "https://www.amazon.com/review/create-review?&asin="+asin+":5";
        if (sessionStorage.getItem("asinRegion") == "CA")
          this.spUrl =
            "https://www.amazon.ca/review/create-review?&asin="+asin+":5";
        if (sessionStorage.getItem("asinRegion") == "EU") {
          if (this.radioVal == "UK") {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin="+asin+":5";
          } else if (this.radioVal == "DE") {
            this.spUrl =
              "https://www.amazon.de/review/create-review?&asin="+asin+":5";
          } else if (this.radioVal == "FR") {
            this.spUrl =
              "https://www.amazon.fr/review/create-review?&asin="+asin+":5";
          } else if (this.radioVal == "IT") {
            this.spUrl =
              "https://www.amazon.it/review/create-review?&asin="+asin+":5";
          } else if (this.radioVal == "ES") {
            this.spUrl =
              "https://www.amazon.es/review/create-review?&asin="+asin+":5";
          } else {
            this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B08RN41KHF:5";
          }
        }
      } else if (spId == "WN1") {
        this.spId = "WN1";
        this.sp_img = WN1;
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl =
            "https://www.amazon.com/review/create-review?&asin=B09BFNZ775:5";
        if (sessionStorage.getItem("asinRegion") == "CA")
          this.spUrl =
            "https://www.amazon.ca/review/create-review?&asin=B09BPY6NVQ:5";
        if (sessionStorage.getItem("asinRegion") == "EU") {
          this.spUrl =
              "https://www.amazon.co.uk/review/create-review?&asin=B09CTGQMN1:5";
        }
      }else if (spId == "T01") {
        this.spId = "T01";
        this.sp_img = T01;
        if (sessionStorage.getItem("asinRegion") == "US")
          this.spUrl = "https://www.amazon.com/review/create-review?&asin=B082V7WB61:5";
      }
    },

    checkEmail(email) {
      var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      if (reg.test(email)) {
        return true;
      } else {
        return false;
      }
    },

    showNavOverlay() {
      this.showNavContentOverlay = true;
    },

    showNavOverlayWithSubject(menu) {
      if (menu.showOverlay) {
        this.overlayContentSubject = menu.tag;
        this.overlayContent = menu;
        this.showNavContentOverlay = true;
      }
    },

    hideNavOverlay() {
      this.showNavContentOverlay = false;
    },

    getYourAccountUrl() {
      return "/ya/" + this.customerId;
    },
  },

  computed: {
    ...mapState("nav", ["showSearchBar"]),
  },
};
</script>>

<style scope>
/* 动画效果属性 */
.hide-enter-active {
  transition: all 0.35s;
}

.hide-leave-active {
  transition: all 0.35s;
}

.hide-enter,
.hide-leave-to {
  /* // transform: translateX(-400*@vw); */
  transform: scale(0);
  /* // transform: rotate(190deg); */
  opacity: 0;
}
.box_hezi_twoDiv {
  width: 100%;
  height: 487px;
  /* background-color:#F5F5F5; */
  background-color: rgb(243, 243, 243);
  border: 1px solid rgb(129, 129, 129);
  border-radius: 15px;
  overflow: hidden;
}
.hezi_onediv {
  display: flex;
  justify-content: flex-end;
}
.box_hezi_oneDiv {
  /* float: right; */
  margin-right: 40px;
  width: 15px;
  height: 13px;
  background-image: url("../../assets/sanjiao.png");
  background-size: 100% 100%;
}
.position {
  position: relative;
}
.box_hezi {
  width: 1000px;
  height: 500px;
  /* border: 1px solid red; */
  position: absolute;
  /* text-align: right; */
  right: -30px;
}

.box_hezi_Image {
  height: 100%;
  width: 50%;
  float: left;
}
.box-right-form {
  height: 100%;
  width: 50%;
  float: left;
}

.showImage {
  margin: 10%;
  height: 80%;
}

.cuimage {
  margin: 0%;
  height: 100%;
}
.box-select-product {
  margin-top: 1%;
  /* margin-left: 60%; */
  width: 60%;
  border-bottom: solid 1px;
  border-radius: 2px;
}
.box-text {
  margin-top: 3%;
  margin-left: 55%;
  width: 35%;
}
.box-text img {
  width: 6%;
  margin-right: 2%;
}
.box-select-product-from {
  margin-top: 2%;
  margin-left: 55%;
}
.box-select-product-from input {
  float: left;
  width: 40%;
  margin-right: 6%;
  margin-bottom: 2%;
  border-bottom: 1px solid rgb(107, 107, 107);
}
#selectMessage {
  width: 86%;
  margin-bottom: 2%;
  border-bottom: 1px solid rgb(107, 107, 107);
}

.box-select-product-from button {
  background-color: rgb(107, 107, 107);
  width: 30%;
  border-radius: 5px;
}

.box-title {
  margin-top: 12%;
  margin-left: 25%;
  width: 90%;
  margin-bottom: 5%;
}

.box-title2 {
  margin-top: 20%;
  margin-left: 0%;
  width: 90%;
  margin-bottom: 2%;
}
.grade {
  margin-top: 0%;
  padding-left: 2%;
}
.star {
  margin-top: 0%;
  margin-bottom: 2%;
}
.box-title-image {
  float: left;
  height: 30px;
  width: 30px;
}
.box-purchasing-channel {
  margin-top: 3%;
  margin-left: 23%;

  width: 210px; /*宽度*/
  height: 30px; /*高度*/

  background: rgba(0, 0, 0, 0.2);

  border-radius: 5px;
  /* overflow: hidden; */
}
.box-purchasing-channel select {
  background: transparent; /*透明*/
  border: none;
  padding-left: 10px;
  width: 210px; /*比上面设置的略宽*/
  height: 100%;
  border-radius: 10px;
  color: black;
  font-family: "微软雅黑";
}
.dialog-bt {
  width: 30px;
  margin-bottom: 55%;
}

.box-content-text {
  margin-top: 0%;
  margin-left: 15%;
  width: 70%;
}
.box-content-server {
  font-family: "微软雅黑";
  margin-top: 10%;
}
.box-content-server img {
  height: 20px;
}
.box-amazon-bt {
  margin-top: 10%;
  margin-left: 20%;
  margin-bottom: 10%;
}

.from input {
  margin-top: 0%;
  border-bottom: gray 1px solid;
  outline: none;
  width: 40%;
  float: left;
  margin-right: 6%;
}
#gradeReview {
  margin-top: 0%;
  border-bottom: gray 1px solid;
  outline: none;
  width: 86%;
}

input::-webkit-input-placeholder {
  transition: 0.5s;
  color: #999;
}
input:focus::-webkit-input-placeholder {
  color: red;
  text-align: center;
}
.from button {
  margin-left: 5%;
  margin-top: 10%;
  width: 100px;
  height: 30px;
  color: white;
  background-color: #333333;
  border-radius: 15px;
  float: left;
}

.from button:hover {
  color: red;
}

.after-contact-box {
  margin-top: 5%;
  margin-left: 50%;
  font-size: 12px;
}

.after-contact-box p {
  line-height: 9px;
}

.star img {
  height: 2.3em;
  margin-left: 5%;
}
.gradefrom {
  margin-left: 5%;
  width: 90%;
}

.gradefrom input {
  margin-top: 0%;
  margin-bottom: 2%;
}
.share {
  margin-left: 7%;
  width: 40%;
}
.share h4 {
  margin-top: 15%;
}
.share span {
  margin-top: 10%;
}
.share img {
  margin-top: 10%;
}
</style>

<style >
#onebyone-navigation {
  background-color: white;
  font-weight: 500;
  position: fixed;
  width: 100%;
  z-index: 1;
}

.nav-icon {
  background-size: 200px;
  width: 40px;
}

.nav-item {
  height: var(--nav-height);
}

.nav-icon.nav-icon-account {
  background-position: -50px 15px;
}

.nav-icon.nav-icon-search {
  background-position: -100px 15px;
  cursor: pointer;
}

#onebyone-nav-items-wrapper {
  position: relative;
  max-width: 1000px;
}

#left-navigation {
  width: 500px;
}

#right-navigation {
  position: absolute;
  right: 40px;
  top: 0px;
}

.nav-logo {
  position: absolute;
  left: 30px;
}

.menu-item {
  transition: border-bottom-color 0.5s linear;
  border-radius: 0px !important;
  border-bottom-color: white;
}

.menu-item > a {
  color: #333333 !important;
}

.menu-item:hover {
  border-bottom: 4px solid #e2211c;
}

/*************************************
 ***** SubNav overlay css section ****
 *************************************/
.nav-overlay {
  position: absolute;
  width: 100%;
  z-index: 4;
  background-color: #ffffff;
  box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2),
    0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12);
}

.category-title {
  color: #333333;
  font-weight: 600;
}

.sub-nav-content {
  margin-top: 39px;
}

.sub-nav-content:nth-child(2) {
  margin-left: 150px;
}

.category-item {
  margin-top: 16px;
  position: relative;
  transition: 0.6s;
}

.category-item:hover {
  margin-left: 10px;
  padding-left: 5px;
}

.nav-item-link:hover > a {
  color: #999999 !important;
}

.category-item > a {
  color: #666666 !important;
}

.nav-subitem-hover::before {
  transition: opacity 0.6s;
  height: 10px;
  position: absolute;
  left: -9px;
  top: 45%;
  transform: translateY(-50%);
  width: 9px;
  border-bottom: 4px solid #e2211c;
  content: "";
  opacity: 0;
}

.nav-subitem-hover:hover::before {
  opacity: 1;
}

#nav-view-all-product {
  margin-top: 46px;
  margin-bottom: 37px;
}

#nav-view-all-product > a {
  color: #333333;
}

#support-category {
  width: 830px;
  height: 92px;
}

.support-subject {
  position: relative;
  color: #333333 !important;
  transition: 0.6s;
}

.support-subject:hover {
  color: #999999 !important;
}
.signbt {
  margin-top: 15px;
  margin-right: 18px;
}

.signinbt {
  color: #999999;
}
#LoginWithAmazon {
  margin-top: 14px;
  margin-right: 8px;
}

#LoginWithAmazon img:hover {
  border: white solid 1px;
}

.signinbt:hover {
  color: red;
  cursor: pointer;
}

.closeButton {
  float: right;
  margin-top: 4%;
  margin-right: 6%;
  cursor: pointer;
}

.cuclose {
  margin-top: 2%;
  margin-right: 3%;
}

.contact {
  width: 40%;
  margin-left: 5%;
  margin-top: 5%;
}

.contact input {
  width: 42%;
  border-bottom: 1px solid #999999;
  /* border-radius: 5px; */
  float: left;
  margin-right: 6%;
}
#contactMessage {
  width: 90%;
}
.contact button {
  color: white;
  background-color: black;
  margin-right: 10%;
  width: 100px;
  border-radius: 5px;
}
/* .loginsuccessful{
  margin-top:10%;
  margin-left: 58%;
  width: 100%;
}
.loginsuccessful  :first-child{
  margin-left: 8%;
}
.loginsuccessful  :last-child{
  margin-left: 11%;
  border-bottom: #333333 solid 1px;
}
.loginsuccessful img{
  width: 5%;
   margin-left: 11%;
} */

#loginsuccessful1 {
  margin-bottom: 3em;
  /* width: 65%;
 margin-left: 15%; */
  margin-top: 5%;
  text-align: center;
}

#loginsuccessful1-buttom {
  margin-bottom: 3em;
  text-align: center;
}
#logingouzi1 {
  width: 15%;
  margin-top: 5%;
  margin-bottom: 5%;
  margin-left: 0%;
}
#titel-congratulations1 {
  text-align: center;
}
#loginsuccessful1-content {
  margin-bottom: 5%;
}

#affrim2 {
  color: white;
  /* margin-top: 10%; */
  background-color: gray;
  width: 6em;
  height: 1.8em;
  /* text-align:center; */
  /* margin: 0 auto;  */
  margin-left: 70%;
  border-radius: 0.8em;
}

.received :first-child {
  width: 80%;
  margin-left: 6%;
  margin-top: 20%;
  text-align: center;
}
.clickclose {
  margin-top: 3em;
  margin-left: 11em;
  /* padding-bottom: 3px; */
  width: 3em;
  cursor: pointer;
  /* border-radius: 5px; */
  /* background-color: #999999; */
  border-bottom: 1px solid black;
}
#logingouzi {
  width: 2em;
  margin-left: 8em;
}
.eu_state_box {
  margin-left: 8em;
}

.tagClass1 {
  float: left;
  padding-left: 0.5em;
  padding-right: 0.5em;
  background-color: DimGrey;
  margin-right: 0.5em;
  border-radius: 6px;
  height: 1.6em;
  font-size: 90%;
  color: white;
  text-align: center;
  cursor: pointer;
  margin-bottom: 1em;
}
.getWarranty {
  font-size: 1.3em;
  margin-left: 1.5em;
}
.getWarranty2 {
  font-size: 1.3em;
  margin-left: 4.5em;
}
.box-amazon-flag {
  margin-left: 10%;
}
.box-amazon-bt input {
  border-bottom: 1px solid black;
}
</style>
